/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 43f96b2d (Wed Dec  3 21:51:26 UTC 2025)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  EventCategory,
  FetchEventCategoriesResponseEventTypes,
  FetchEventCategoriesResponseEventTypesFromJSON,
  FetchEventCategoriesResponseEventTypesToJSON,
} from './'

/**
 *
 * @export
 * @interface FetchEventCategoriesResponseCategories
 */
export interface FetchEventCategoriesResponseCategories {
  /**
   *
   * @type EventCategory
   * @memberof FetchEventCategoriesResponseCategories
   */
  name: EventCategory
  /**
   *
   * @type number
   * @memberof FetchEventCategoriesResponseCategories
   */
  order: number
  /**
   *
   * @type {Array<FetchEventCategoriesResponseEventTypes>}
   * @memberof FetchEventCategoriesResponseCategories
   */
  eventTypes: Array<FetchEventCategoriesResponseEventTypes>
}

export function FetchEventCategoriesResponseCategoriesFromJSON(
  json: any
): FetchEventCategoriesResponseCategories {
  return FetchEventCategoriesResponseCategoriesFromJSONTyped(json, false)
}

export function FetchEventCategoriesResponseCategoriesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchEventCategoriesResponseCategories {
  if (json === undefined || json === null) {
    return json
  }
  return {
    name: json['name'],
    order: json['order'],
    eventTypes: (json['eventTypes'] as Array<any>).map(
      FetchEventCategoriesResponseEventTypesFromJSON
    ),
  }
}

export function FetchEventCategoriesResponseCategoriesToJSON(
  value?: FetchEventCategoriesResponseCategories | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    order: value.order,
    eventTypes: (value.eventTypes as Array<any>).map(
      FetchEventCategoriesResponseEventTypesToJSON
    ),
  }
}
